import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'removeVersion'
})
export class RemoveVersionPipe implements PipeTransform {
  constructor() {}
  transform(url: string): string {
    if (!url) {
      return;
    }

    const indexVersion = url.indexOf('?version=');

    if (indexVersion === -1) {
      return url;
    }

    return url.substr(0, indexVersion);
  }
}
